<template>
  <div class="list-navigtion-item">
    <!-- Previous button -->
    <a
      href="javascript:;"
      class="item-navigation navigation-left"
      :class="{ 'disabled-item': currentPage === 1 }"
      @click="handlePageChange(currentPage - 1)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="12"
        viewBox="0 0 9 12"
        fill="none"
      >
        <path
          d="M8.16016 1.41L3.58016 6L8.16016 10.59L6.75016 12L0.750156 6L6.75016 0L8.16016 1.41Z"
          fill="#414B5B"
        />
      </svg>
    </a>

    <!-- Page numbers -->
    <template v-for="(page, index) in displayedPages" :key="index">
      <template v-if="page === '...'">
        <a href="javascript:;" class="item-navigation">...</a>
      </template>
      <template v-else>
        <a
          href="javascript:;"
          class="item-navigation"
          :class="{ active: currentPage === page }"
          @click="handlePageChange(page)"
        >
          {{ page }}
        </a>
      </template>
    </template>

    <!-- Next button -->
    <a
      href="javascript:;"
      class="item-navigation navigation-right"
      :class="{ 'disabled-item': currentPage === totalPages }"
      @click="handlePageChange(currentPage + 1)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="12"
        viewBox="0 0 9 12"
        fill="none"
      >
        <path
          d="M0.839844 1.41L5.41984 6L0.839844 10.59L2.24984 12L8.24984 6L2.24984 0L0.839844 1.41Z"
          fill="#414B5B"
        />
      </svg>
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  currentPage: number;
  totalRecords: number;
  pageSize: number;
  pageRange?: number;
}

interface Emits {
  (e: "page-change", page: number): void;
  (e: "update:currentPage", page: number): void;
}

const props = withDefaults(defineProps<Props>(), {
  currentPage: 1,
  pageRange: 5,
});

const emit = defineEmits<Emits>();

type PageItem = number | "...";

// Tính tổng số trang dựa trên tổng số bản ghi và kích thước trang
const totalPages = computed(() =>
  Math.ceil(props.totalRecords / props.pageSize)
);

const displayedPages = computed<PageItem[]>(() => {
  const pages: PageItem[] = [];
  const currentPage = props.currentPage;
  const range = props.pageRange;
  const total = totalPages.value;

  // Tính khoảng trang cần hiển thị
  let start = Math.max(currentPage - Math.floor(range / 2), 1);
  let end = Math.min(start + range - 1, total);

  // Điều chỉnh start nếu end đã chạm giới hạn
  if (end === total) {
    start = Math.max(end - range + 1, 1);
  }

  // Điều chỉnh end nếu start là 1
  if (start === 1) {
    end = Math.min(range, total);
  }

  // Thêm trang đầu và dấu ...
  if (start > 1) {
    pages.push(1);
    if (start > 2) {
      pages.push("...");
    }
  }

  // Thêm các trang trong khoảng
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  // Thêm dấu ... và trang cuối
  if (end < total) {
    if (end < total - 1) {
      pages.push("...");
    }
    if (end !== total) {
      pages.push(total);
    }
  }

  return pages;
});

const handlePageChange = (page: number): void => {
  console.log(page);
  if (page >= 1 && page <= totalPages.value && page !== props.currentPage) {
    emit("page-change", page);
    emit("update:currentPage", page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
</script>
